export const listItems = ["Change commerciale", "Change amministrativo", "Change tecnico"]